import React from 'react';

import { OfferReviewCard } from 'sellDirect/components/homeWalkthrough/OfferReviewCard';
import { Box, Text, Input, InputProps } from '@opendoor/bricks/core';
import { ORVAData } from 'sellDirect/OfferContext';

interface ORVAInfoCardProps {
  phoneNumber?: string;
  onPhoneNumberChange: InputProps['onChange'];
  hasError?: boolean;
  disable?: boolean;
  orvaData: ORVAData;
}

// component-test-check-ignore
/** Shared component that renders the offer review schedule card with phone number input. */
export const ORVAInfoCard: React.FC<ORVAInfoCardProps> = ({
  phoneNumber,
  onPhoneNumberChange,
  hasError,
  disable = false,
  orvaData,
}) => (
  <>
    {/* For the SSVA targeting experiment, show error above the schedule card */}
    {hasError && (
      <Text width="100%" mb={5} fontSize="s0" color="red50" textAlign="center">
        Oops, something went wrong. Please try again in a few hours or contact your experience
        partner.
      </Text>
    )}
    <OfferReviewCard
      onlyShowCta
      iconCta
      flexProps={{ width: '100%', mt: 3 }}
      phoneNumber={phoneNumber}
      orvaData={orvaData}
    />
    {!orvaData.earliestAvailabilityError && (
      <Box color="neutrals100" mt={['24px', null, 6]} alignSelf="start" width="100%">
        <Input
          analyticsName="cake-orva-info-card-phone"
          data-testid="orva-phone-input"
          width="100%"
          label={
            <Text fontSize={'s1'} fontWeight="semibold">
              Your phone number
            </Text>
          }
          id="va-selection-phone-input"
          type="tel"
          placeholder={undefined}
          value={phoneNumber}
          onChange={(_event, value) => onPhoneNumberChange(_event, value)}
          unboundedWidth
          disabled={disable}
        />
      </Box>
    )}
  </>
);
